<template>
    <div>
        <v-autocomplete
            v-model="item"
            :label="label"
            :items="items"
            :item-value="itemValue || 'id'"
            :item-text="itemText || 'name'"
            outlined
            dense
            :disabled="disabled"
            :loading="loading"
            :return-object="returnObject"
            :multiple="multiple"
            :readonly="readonly"
            :chips="multiple"
            :deletable-chips="multiple && !readonly"
            :clearable="!(readonly || notClearable)"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="input"
            @change="change"
            @click="click"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref, watch} from "vue";

export default {
    name: "WEnumSelect",
    props: {
        value: [Number, String, Boolean, Object, Array],
        rules: Array,
        label: String,
        itemValue: String,
        itemText: String,
        loading: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        multiple: Boolean,
        notClearable: Boolean,
        returnObject: Boolean,
        items: Array
    },
    emits: ["click", "change"],
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const item = ref(null);

        watch(() => props.value, () => {
            item.value = props.value;
        });

        onMounted(() => {
            if (props.value !== null && props.value !== undefined)
                item.value = props.value;
        });

        function input(value) {
            emit("input", value);
        }

        function click() {
            emit("click");
        }

        function change() {
            emit("change");
        }

        return {
            loading,
            inputColor,
            backgroundColor,
            item,
            input,
            click,
            change
        };
    }
};
</script>

<style scoped></style>